const NewShoppingCartIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_133_6203"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_133_6203)">
      <path
        d="M4.76917 14.3718C4.44528 14.3718 4.16989 14.2583 3.943 14.0313C3.71611 13.8044 3.60267 13.5291 3.60267 13.2052C3.60267 12.8812 3.71611 12.6057 3.943 12.3788C4.16989 12.1519 4.44528 12.0385 4.76917 12.0385C5.09317 12.0385 5.36861 12.1519 5.5955 12.3788C5.82239 12.6057 5.93583 12.8812 5.93583 13.2052C5.93583 13.5291 5.82239 13.8044 5.5955 14.0313C5.36861 14.2583 5.09317 14.3718 4.76917 14.3718ZM11.2308 14.3718C10.9068 14.3718 10.6314 14.2583 10.4045 14.0313C10.1776 13.8044 10.0642 13.5291 10.0642 13.2052C10.0642 12.8812 10.1776 12.6057 10.4045 12.3788C10.6314 12.1519 10.9068 12.0385 11.2308 12.0385C11.5547 12.0385 11.8301 12.1519 12.057 12.3788C12.2839 12.6057 12.3973 12.8812 12.3973 13.2052C12.3973 13.5291 12.2839 13.8044 12.057 14.0313C11.8301 14.2583 11.5547 14.3718 11.2308 14.3718ZM4.01017 3.83333L5.7 7.37183H10.2448C10.2833 7.37183 10.3175 7.36222 10.3475 7.343C10.3774 7.32378 10.403 7.29706 10.4243 7.26283L12.2128 4.01283C12.2385 3.96583 12.2406 3.92417 12.2192 3.88783C12.1978 3.8515 12.1615 3.83333 12.1102 3.83333H4.01017ZM3.53083 2.83333H12.7872C13.0598 2.83333 13.266 2.94939 13.4057 3.1815C13.5454 3.4135 13.5521 3.65044 13.4257 3.89233L11.2897 7.7615C11.1803 7.95383 11.0357 8.10361 10.8558 8.21083C10.6758 8.31817 10.4786 8.37183 10.2642 8.37183H5.4L4.62817 9.782C4.59394 9.83333 4.59289 9.88889 4.625 9.94867C4.657 10.0086 4.70506 10.0385 4.76917 10.0385H12.3973V11.0385H4.76917C4.32472 11.0385 3.99078 10.8468 3.76733 10.4635C3.54378 10.0802 3.53589 9.69744 3.74367 9.31533L4.69483 7.60517L2.26933 2.5H1V1.5H2.8975L3.53083 2.83333Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default NewShoppingCartIcon;
